<template>
  <div class="saveRes">
    <div ref="saveDiv" v-show="firstFlag">
      <div class="hd">
        <img :src="hdimg" class="ml-20 fl mr-10" />
        <p class="f16 mt-20">
          {{ name }}
          <span v-if="isVip" class="vip"></span>
          <span v-if="!isVip" class="vip-no"></span>
        </p>
        <p class="f10 gray mt-10">测评完成时间: &nbsp;{{ finishTime }}</p>
      </div>
      <div class="content mt-30">
        <img :src="resultImg" class="hdImg" />
        <img :src="resBgImg" class="bgImg" />
        <div
          id="myChart"
          :style="{
            width: '6.5rem',
            height: '6.5rem',
            marginLeft: '17.5%',
            marginTop: '-45%',
          }"
        ></div>
        <div v-for="(item, index) in dimensionless" :key="index">
          <p class="hd blue f24" v-if="dimensionless.length > 1">
            {{ item.number }}
          </p>
          <p class="blue f20">
            <b>{{ item.name }}</b>
          </p>
          <p class="orange mt-20 name">
            <span>{{ item.level }}</span
            ><span class="dot"></span><span>{{ item.score }}分</span>
          </p>
          <hr />
          <!-- <p class="bg f16 mt-10">{{item.description}}</p> -->
          <div class="bg f16 mt-10">
            <p v-for="text in getText(item.description)">{{ text }}</p>
          </div>
        </div>
      </div>
      <div class="ft_footer">
        <div class="ft_footer_left">
          <div class="ft_title">
            <img src="../../../assets/img/logo_pic.png" alt="" />
            <span>酷炫脑测评</span>
          </div>
          <p>扫描二维码,来“酷炫脑测评”做心理测评吧</p>
        </div>
        <div>
          <div id="qrCode" class="ft_footer_right" ref="qrcode"></div>
        </div>
      </div>
    </div>
    <img
      :src="imgData"
      ref="resImg"
      v-show="!firstFlag"
      crossorigin="anonymous"
      class="savePic"
    />
  </div>
</template>

<script>
import { getRelatedTest, getTestRes } from "@/http/api";
import { mapGetters } from "vuex";

import html2canvas from "./../../../utils/html2canvas";
import QRCode from "qrcodejs2";

export default {
  name: "save",
  data() {
    return {
      isVip: false,
      firstFlag: true,
      imgData: "",
      isCommented: "",
      hdimg: "",
      resultImg: "",
      // resultImg: require('../../../assets/img/my/banner.png'),
      resBgImg: require("../../../assets/img/test/score_bg.png"),
      name: "用户名",
      finishTime: "",
      dimensionless: [],
      maxScore: 0,
      minScore: 0,
      intervalLength: 0,
      chart: "",
    };
  },
  computed: {
    ...mapGetters(["user", "eval_id", "appraisal_id"]),
  },
  created() {},
  updated() {},
  watch: {},
  mounted() {
    this.hdimg = this.user.avatar;
    console.log("this.hdimg", this.hdimg);
    this.name = this.user.nick_name;
    this.isVip = this.user.is_vip.key === "yes";
    getTestRes({ appraisal_id: this.appraisal_id })
      .then((res) => {
        console.log("测试结果", res.data);
        this.finishTime = res.data.created_at;
        this.dimensionless = res.data.result.dimensionless;
        this.resultImg = res.data.evaluation.home_image;
        let valueArr = [];
        let mount;
        this.maxScore = res.data.result.max_score;
        this.minScore = res.data.result.min_score;
        this.intervalLength = res.data.result.interval_length;
        let indicator = this.dimensionless.map((u) => {
          valueArr.push(u.score - this.minScore);
          return {
            text: parseInt(valueArr) + this.minScore + "分",
            max: this.intervalLength,
          };
        });
        if (this.dimensionless.length === 1) {
          mount = 1;
        }
        this.drawLine(valueArr, indicator, mount);
        if (res.data.is_commented.key === "yes") {
          this.isCommented = true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  beforeDestroy() {},
  methods: {
    getText(desc) {
      // console.log(desc)
      // console.log(desc.split('\n'))
      return desc.split("\\n");
    },
    drawLine(valueArr, indicatorArr, params) {
      let echarts = require("echarts/lib/echarts");
      require("echarts/lib/component/tooltip");
      require("echarts/lib/component/title");
      require("echarts/lib/component/legend");
      let myChart;
      console.log("params", params);
      let options;
      if (params === 1) {
        require("echarts/lib/chart/pie");
        require("echarts/lib/component/graphic");
        myChart = echarts.init(document.getElementById("myChart"));

        options = {
          animation: false,
          graphic: {
            //图形中间文字
            type: "text",
            left: "center",
            top: "center",
            style: {
              text: parseInt(valueArr) + this.minScore + "分",
              textAlign: "center",
              fill: "#7487C3",
              fontSize: 18,
            },
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["50%", "70%"],
              avoidLabelOverlap: false,
              color: ["#ECEFF5", "#7487C3"],
              label: {
                show: false,
                position: "center",
              },
              data: [
                { value: this.intervalLength - valueArr },
                { value: valueArr },
              ],
            },
          ],
        };
      } else {
        require("echarts/lib/chart/radar");
        require("echarts/lib/component/radar");
        myChart = echarts.init(document.getElementById("myChart"));

        options = {
          radar: [
            {
              indicator: indicatorArr,
              center: ["50%", "50%"],
              radius: ["0%", "55%"], // 修改大小
              startAngle: 90,
              splitNumber: 4,
              shape: "circle",
              name: {
                formatter: "{value}",
                textStyle: {
                  color: "#72ACD1",
                },
              },
              splitArea: {
                areaStyle: {
                  color: [
                    "#c5cadd",
                    "#afb8d5",
                    "#a2accd",
                    "#8a98c4",
                    "#7688be",
                  ],
                },
              },
              axisLine: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.5)",
                },
              },
              splitLine: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.5)",
                },
              },
            },
          ],
          series: [
            {
              name: "雷达图",
              type: "radar",
              itemStyle: {
                normal: {
                  color: "rgba(255,225,255,.3)",
                  lineStyle: {
                    color: "rgba(255,225,255,.3)",
                  },
                },
              },
              emphasis: {
                lineStyle: {
                  width: 2,
                  color: "white",
                },
              },
              data: [
                {
                  value: valueArr,
                  areaStyle: {
                    color: "#F2F2F2",
                  },
                },
              ],
            },
          ],
        };
      }
      myChart.setOption(options);
      this.$nextTick(() => {
        this.bindQRCode();
      });
    },
    // 生成二维码
    bindQRCode() {
      let t = this;
      console.log(this.$refs);
      new QRCode(this.$refs.qrcode, {
        text: "http://h5.coolbrainscience.cn",
        width: this.$refs.qrcode.clientWidth - 4,
        height: this.$refs.qrcode.clientHeight - 4,
        colorDark: "#7487C3", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
      this.createPicture();
    },
    createPicture() {
      let content = this.$refs.saveDiv;
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let scale = window.devicePixelRatio;
      // console.log(width, height, scale)
      let opt = {
        // scale: scale,
        useCORS: true,
        tainttest: true,
        // allowTaint: true,
        backgroundColor: "#fff",
        width: width,
        height: height,
      };
      setTimeout(() => {
        html2canvas(this.$refs.saveDiv, opt).then((canvas) => {
          var imgData = canvas.toDataURL("image/jpeg");
          // console.log('是base64',isInlineBase64Image(imgData))
          this.imgData = imgData;
          let resDom = this.$refs.resImg;
          console.log("结果", this.imgData);
          resDom.style.width = width * scale;
          resDom.style.height = height * scale;
          this.firstFlag = false;
        });
      }, 500);
    },
    getPic() {
      this.createPicture();
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.hd {
  img {
    width: 1.8rem;
    // height: 65px;
    border: 1px solid #fff;
    border-radius: 50%;
  }
}
.content {
  position: relative;
  text-align: center;
  .bgImg {
    position: absolute;
    display: block;
    height: 4.5rem;
    width: 70%;
    margin-top: -4.55rem;
    margin-left: 15%;
  }
  .hdImg {
    border-radius: 25px;
  }
  img {
    width: 90%;
  }
  .hd {
    background: url("./../../../assets/img/test/arrow.png") no-repeat center
      center;
    background-size: 100%, 100%;
    background-position: left top 0.2rem;
    width: 1.5rem;
    height: 1rem;
    margin: 0 auto;
  }
  .name {
    background: white;
    display: inline-block;
    padding: 0 17px;
  }
  hr {
    border: none;
    margin-top: -0.2rem;
    background-color: orange;
    margin-left: 5%;
    width: 90%;
  }
  .bg {
    background-color: #eceff5;
    padding: 20px;
    line-height: 0.6rem;
    color: #4a4a4a;
    text-indent: 2em;
    text-align: start;
  }
}
.ft {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  img {
    width: 45%;
  }
  .vaSup {
    vertical-align: super;
  }
  .vaSub {
    vertical-align: sub;
  }
}
.savePic {
  width: 100%;
  height: 100%;
  // margin-top: -80%;
  margin-top: 10px;
}
.ft_footer {
  .w(335);
  height: 134px;
  margin: 21px auto 0;
  border-top: 1px solid #eaeaea;
  display: flex;
  padding: 0 23px 0 16px;
  justify-content: space-between;
  .ft_footer_right {
    float: right;
    .w(88px);
    height: 88px;
    border: 3px solid #7487c3;
    padding: 2px;
    border-radius: 8px;
    margin-top: 22px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ft_footer_left {
    margin-top: 22px;
    width: 182px;
    img {
      margin-right: 5px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
    }
    p {
      font-size: 12px;
      color: #9b9b9b;
      line-height: 18px;
      margin-top: 11px;
    }
  }
}
.dot {
  display: inline-block;
  margin: 0 12px;
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background-color: #f7b270;
  transform: translateY(-4px);
}
</style>